import { createSharedComposable } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { ref } from 'vue'

import { useConfigStore } from '@/store/config'
import { useFloorplanStore } from '@/store/floorplan'
import { useTillStore } from '@/store/till'
import { isMobile } from '@/utils/device-type'

export const useHome = createSharedComposable(() => {
  const configStore = useConfigStore()
  const floorplanStore = useFloorplanStore()
  const tillStore = useTillStore()

  const { config } = storeToRefs(configStore)
  const { floorplanIds } = storeToRefs(floorplanStore)
  const { shiftsEnabled, selectedCashTillIsStarted, shiftIsStarted } = storeToRefs(tillStore)

  const activeMenu = ref<string>()

  const defaultRestaurantRoute =
    config.value.fastMode && config.value.fastModeHome && !isMobile.value
      ? 'fastMode'
      : floorplanIds.value.length > 0
        ? 'floorplan'
        : 'floatingTabs'

  const activeChildRoute = ref<Record<string, string>>({
    restaurant: defaultRestaurantRoute,
    toGo: 'delivery',
    reservations: 'reservationsList'
  })

  function checkRedirect() {
    if (shiftsEnabled.value && (!selectedCashTillIsStarted.value || !shiftIsStarted.value)) {
      return { name: 'employees' }
    } else if (activeMenu.value) {
      return { name: activeMenu.value }
    } else if (config.value.fastMode && config.value.fastModeHome && !isMobile.value) {
      activeMenu.value = 'fastMode'
      return {
        name: 'fastMode'
      }
    } else if (floorplanIds.value.length > 0) {
      activeMenu.value = 'floorplan'
      return { name: 'floorplan' }
    } else {
      activeMenu.value = 'delivery'
      return { name: 'delivery' }
    }
  }

  function resetToHome() {
    activeMenu.value = undefined
  }

  return {
    activeMenu,
    activeChildRoute,

    checkRedirect,
    resetToHome
  }
})
